import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

const rapid7Domains: Record<string, string> = {
  us: "us.api.insight.rapid7.com",
  us2: "us2.api.insight.rapid7.com",
  us3: "us3.api.insight.rapid7.com",
  eu: "eu.api.insight.rapid7.com",
  ca: "ca.api.insight.rapid7.com",
  au: "au.api.insight.rapid7.com",
  ap: "ap.api.insight.rapid7.com",
};

function getRapid7Domain(region = ""): string {
  return (
    rapid7Domains[region] || rapid7Domains.us || "us.api.insight.rapid7.com"
  );
}

export const rapid7 = defineConnector({
  identifier: "rapid7",
  name: "Rapid7",
  tagLine: "Security analytics and SIEM",
  logo,
  protocol: "http",
  tags: ["featured", "security"],
  defaultUrlPattern: ({ region }) => domainToRegex(getRapid7Domain(region)),
  auth: (app) => headerAuth([{ name: "X-Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Rapid7 Insight Platform](https://insight.rapid7.com) and sign in. Navigate to **Platform Settings > API Keys** to generate a new API key. This key works across InsightAppSec, InsightIDR, InsightOps, InsightConnect, Insight account controls, and tCell.",
        },
      ],
    },
    {
      title: "Enter your Rapid7 details",
      items: [
        {
          kind: "input",
          label: "Rapid7 API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "select",
          label: "Region",
          required: true,
          defaultValue: "us",
          target: { kind: "configuration", field: "region" },
          helperText:
            "Choose the cloud storage region shown in the upper-right corner of the Insight home page.",
          options: [
            { label: "United States - 1", value: "us" },
            { label: "United States - 2", value: "us2" },
            { label: "United States - 3", value: "us3" },
            { label: "Europe", value: "eu" },
            { label: "Canada", value: "ca" },
            { label: "Australia", value: "au" },
            { label: "Japan", value: "ap" },
          ],
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ region }) => `https://${getRapid7Domain(region)}/validate`,
  },
});
